import fCore 								from 'foundation-sites/dist/js/plugins/foundation.core.js';
import fInterchange 			 	from 'foundation-sites/dist/js/plugins/foundation.interchange.js';
import fReveal 							from 'foundation-sites/dist/js/plugins/foundation.reveal.js';
import fMediaQuery 					from 'foundation-sites/dist/js/plugins/foundation.util.mediaQuery.js';
import fTimerAndImageLoader from 'foundation-sites/dist/js/plugins/foundation.util.timerAndImageLoader.js';
import fBox 								from 'foundation-sites/dist/js/plugins/foundation.util.box.js';
import fTrigger 					  from 'foundation-sites/dist/js/plugins/foundation.util.triggers.js';
import fKeyboard					  from 'foundation-sites/dist/js/plugins/foundation.util.keyboard.js';
import fMotion 					    from 'foundation-sites/dist/js/plugins/foundation.util.motion.js';
import fEqualizer 					from 'foundation-sites/dist/js/plugins/foundation.equalizer.js';
import fTabs	from 'foundation-sites/dist/js/plugins/foundation.tabs.js';

class FoundationInit {

	constructor(){
		this._init();
		this.ongletTabls = jQuery('.tabs');
	}

 	_init(){
    
	  	document.addEventListener('DOMContentLoaded', (event) => {
	    	jQuery(document).foundation();
	  	});

	    jQuery('.recherche-document-resultat__noDocument').map(function(){
    		var numBoucle = jQuery(this).attr('numero_boucle');
    		jQuery('#panel'+numBoucle).remove();
    		jQuery('.tabs-title--'+numBoucle).remove();
    	});
	}

}

export const foundationInit = new FoundationInit();
